import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../lib/cn";
import { Alert, AlertDescription, AlertTitle } from "./alert";
import { CopyReferenceButton, DebugDetailBlock, } from "./error-reference";
/**
 * THE WRITE-PATH TWIN OF `QueryErrorState`. A save, delete, publish or export was
 * refused, and this is the one control that says so.
 *
 * Before issue #57 the app had three user-facing error surfaces and only two carried a
 * `requestId`: a failed read (`QueryErrorState`) and a render crash (`ErrorFallback`)
 * both showed one, while a refused write showed a hand-rolled `<Alert variant="danger">`
 * — copy-pasted across sixteen files — that showed none. The id existed for every one of
 * those failures the whole time; nothing rendered it. So a customer reporting "it
 * wouldn't save" could not be correlated to the server log line that says why, which is
 * precisely the report that most needs it.
 *
 * `variant="danger"` gives the wrapper `role="alert"` from `Alert` itself, so the refusal
 * is announced when it appears without every call site remembering the attribute.
 */
export const MutationErrorAlert = forwardRef(function MutationErrorAlert({ className, title, messages, reference, debug, action, ...props }, ref) {
    // Nothing to announce. A caller that clears its error state re-renders with an empty
    // list rather than unmounting, and an empty red box is worse than no box.
    if (messages.length === 0)
        return null;
    return (_jsxs(Alert, { ref: ref, variant: "danger", className: cn(className), ...props, children: [title === undefined ? null : _jsx(AlertTitle, { children: title }), messages.length === 1 ? (_jsx(AlertDescription, { children: messages[0] })) : (_jsx("ul", { className: "flex flex-col gap-1 text-sm text-muted text-pretty", children: messages.map((message) => (_jsx("li", { children: message }, message))) })), reference === null ? null : _jsx(CopyReferenceButton, { reference: reference }), debug === undefined ? null : _jsx(DebugDetailBlock, { debug: debug }), action === undefined ? null : _jsx("div", { className: "mt-3", children: action })] }));
});
MutationErrorAlert.displayName = "MutationErrorAlert";
//# sourceMappingURL=mutation-error-alert.js.map